import { defineComponent as _defineComponent } from 'vue'
import CustomerRequiredDetailsForm from '@/components/CustomerRequiredDetailsForm.vue'
import auth from '@/store/modules/auth'
import { useDisplay } from '@/composables/useDisplay'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotCustomerDetails',
  emits: ['update:customer', 'form:validate'],
  setup(__props, { emit }) {

const { smAndDown } = useDisplay()




return { __sfc: true,smAndDown, emit, CustomerRequiredDetailsForm, auth }
}

})